import React from 'react';
import { CoverHero } from '../components/advertorial/CoverHero';
import { ArticleSection } from '../components/advertorial/ArticleSection';
import { CtaBlock } from '../components/advertorial/CtaBlock';
import { StickyCta } from '../components/advertorial/StickyCta';
import { ReadingProgress } from '../components/advertorial/ReadingProgress';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { useResourceHints, type ResourceHint } from '../hooks/useResourceHints';
import { cover, sections, cta, stickyCta, metaPixel } from '../data/advertorial';
const PIXEL_HINTS: ResourceHint[] = [{
  href: 'https://connect.facebook.net'
}];
interface AdvertorialProps {
  showStickyCta: boolean;
  showReadingProgress: boolean;
}
export function Advertorial({
  showStickyCta,
  showReadingProgress
}: AdvertorialProps) {
  useResourceHints(PIXEL_HINTS);
  useMetaPixel({
    pixelId: metaPixel.id,
    pageViewEvent: metaPixel.pageViewEvent
  });
  return <div className="min-h-screen w-full bg-ink" data-id="element-338" data-mp="8asm2m0g87dg">
      <noscript data-id="element-339" data-mp="2tvaylni6cavg">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${metaPixel.id}&ev=PageView&noscript=1`} data-id="element-340" data-mp="2tvu9ik9epyzz" />
      </noscript>

      {showReadingProgress && <ReadingProgress data-id="element-341" data-mp="2k3oh59f8tfk9" />}

      <CoverHero content={cover} data-id="element-342" data-mp="2g4fne4k7dhop" />

      <main className="relative z-10 -mt-6 rounded-t-[18px] border-t border-white/10 bg-carbon shadow-[0_-30px_70px_rgba(0,0,0,0.65)] md:-mt-8 md:rounded-t-[22px]" data-id="element-343" data-mp="2g3ecq173mx7i">
        <div aria-hidden="true" className="flex justify-center pt-3" data-id="element-344" data-mp="2669rc3l2v5rr">
          <span className="h-1 w-11 rounded-full bg-white/15" data-id="element-345" data-mp="268cod7kndz5z" />
        </div>

        <article className="mx-auto max-w-read px-5 pb-16 pt-10 sm:px-6 md:pb-20 md:pt-16" data-id="element-346" data-mp="217f48pg2uv1u">
          <div className="space-y-12 md:space-y-14" data-id="element-347" data-mp="1x6wceve6pozn">
            {sections.map(section => <ArticleSection key={section.id} section={section} data-id="element-348" data-mp="3vkegq9p5v94w" />)}
          </div>

          <CtaBlock content={cta} data-id="element-349" data-mp="3rknrwbj73330" />
        </article>
      </main>

      <footer className="border-t border-white/[0.07] bg-ink px-5 pb-24 pt-10 sm:px-6 md:pb-10" data-id="element-350" data-mp="1ow5qmrkgxhae">
        <div className="mx-auto max-w-read text-center" data-id="element-351" data-mp="1tnxlheanq96c">
          <p className="font-mono text-[10px] tracking-[0.22em] text-gold/80" data-id="element-352" data-mp="1tph2x881uq9p">
            THE MASCULINE FAITH REVIEW
          </p>
          <p className="mt-3 text-[12.5px] font-light leading-relaxed text-ash/70" data-id="element-353" data-mp="1jxb8zsy8lyrv">
            Contenido informativo de carácter divulgativo. Este reportaje no sustituye el consejo
            médico, psicológico ni pastoral profesional. Los resultados varían según cada persona.
          </p>
          <p className="mt-4 font-mono text-[10px] tracking-[0.12em] text-ash/50" data-id="element-354" data-mp="1ymqy74i4dw5g">
            © {new Date().getFullYear()} — Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {showStickyCta && <StickyCta label={stickyCta.label} hint={stickyCta.hint} buttonLabel={stickyCta.buttonLabel} href={cta.href} data-id="element-355" data-mp="n6afn2b9qzed" />}
    </div>;
}